import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as WarningIcon } from 'products/nomad_insurance/assets/img/icons/warning.svg';
import { ReactComponent as ChatIcon } from 'products/nomad_insurance/assets/img/icons/chat.svg';
import { Wrapper } from './styled';

const Notice = ({ variant, children, className }) => {
  return (
    <Wrapper variant={variant} className={className}>
      {variant === 'warning' && <WarningIcon />}
      {variant === 'info' && <ChatIcon />}
      <div>{children}</div>
    </Wrapper>
  );
};

Notice.propTypes = {
  variant: PropTypes.oneOf(['warning', 'info']),
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

export default Notice;
